import React, {useContext} from 'react';
import {FormFieldConfigSize, FormFieldWidgets} from '@src/@types/components/Form';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import {IFormFieldItemPropsContext} from '@src/@interfaces/contexts/IFormFieldItemPropsContext';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import FormErrorMessage from '@src/components/Form/FormErrorMessage';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import FieldLayout from './extra_row/FieldLayout';
import {FileUploadFieldWidget} from '@src/components/Form/widgets';
import usePermissionGranted from '@src/hooks/usePermissionGranted';
import DismissibleAttach from '@src/components/DismissibleAttach/DismissibleAttach';
import app from '@src/helpers/app';

function PreviewActualField({rowIndex: index, isDisabled, model: passedModel}: {
    rowIndex: number,
    isDisabled?: boolean,
    model?: IOrderModel
}) {
    const {
        fieldName,
        model: contextModel,
        forceDisabled,
        forceReadonly
    } = useContext<IFormFieldItemPropsContext<IOrderModel> | null>(FormFieldItemPropsContext) ?? {};
    const [design] = useContext(FormFieldDesignContext);

    const dot = app('dot-accessor');
    const canEdit = usePermissionGranted('orders@can-edit-products-preview');
    const model = passedModel ?? contextModel ?? {};

    if (!canEdit) {
        const previewsPaths = dot.get<string[] | undefined>(model, `${fieldName}.${index}.previews_public_path`);

        return <div>
            {previewsPaths?.length ? (
                    previewsPaths.map(src => {
                        return <DismissibleAttach key={src} file={{src}} disabled/>;
                    })
            ) : <div>—</div>}
        </div>;
    }

    return <>
        <FileUploadFieldWidget
                id={`${fieldName}.${index}.previews`}
                fieldName={`${fieldName}.${index}.previews`}
                formName="OrderProducts"
                model={model}
                config={{
                    type: FormFieldWidgets.FILE_UPLOAD,
                    mode: 'image',
                    label: 'OrderForm.products.fields.previews',
                    multiple: true,
                    readOnly: design.fieldsAreReadOnly || forceReadonly,
                    disabled: isDisabled || design.fieldsAreDisabled || forceDisabled,
                    size: FormFieldConfigSize.SM,
                    previewSize: FormFieldConfigSize.LG,
                }}
                fieldLabel="OrderForm.products.fields.previews"
                label="OrderForm.products.fields.previews"
        />

        <FormErrorMessage fieldName={`${fieldName}.${index}.previews`}/>
    </>;
}

export function PreviewIndependentField(props: {
    rowIndex: number,
    isDisabled?: boolean,
    model?: IOrderModel
}) {
    return <FieldLayout
            id={null}
            label="OrderForm.products.fields.previews"
            className="mb-3"
    >
        <PreviewActualField {...props}/>
    </FieldLayout>;
}

export function PreviewField({rowIndex: index}: IListColumnProps) {
    return <PreviewActualField rowIndex={index}/>;
}
